/*
  Lucía de Miguel · Carrito que vende: añade desde las recomendaciones sin salir del carrito.
  Usa el mismo contrato de eventos que product-form (CartLinesUpdateEvent) para que el cajón
  se vuelva a pintar solo, con la escalera de descuento y nuevas recomendaciones.
*/
import { CartLinesUpdateEvent } from '@shopify/events';

document.addEventListener('change', (e) => {
  const sel = e.target.closest?.('[data-vrs-rec-variant]');
  if (!sel) return;
  const btn = sel.closest('[data-vrs-rec]').querySelector('[data-vrs-rec-add]');
  btn.disabled = !sel.value;
});

document.addEventListener('click', async (e) => {
  const btn = e.target.closest?.('[data-vrs-rec-add]');
  if (!btn || btn.disabled) return;
  const card = btn.closest('[data-vrs-rec]');
  const sel = card.querySelector('[data-vrs-rec-variant]');
  const msg = card.querySelector('[data-vrs-rec-msg]');
  const id = Number(sel ? sel.value : btn.dataset.variant);
  if (!id) { if (msg) msg.textContent = 'Elige una talla.'; sel?.focus(); return; }
  btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Añadiendo…';
  if (msg) msg.textContent = '';
  const sectionId = btn.closest('cart-items-component')?.dataset.sectionId || 'cart-drawer-section';
  const deferred = CartLinesUpdateEvent.createPromise();
  btn.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: id, quantity: 1 }], promise: deferred.promise }));
  try {
    const res = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: sectionId, sections_url: window.location.pathname }),
    });
    const json = await res.json();
    if (!res.ok || json.status) throw new Error(json.description || json.message || 'No se pudo añadir.');
    const cart = await (await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })).json();
    deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { sections: json.sections, items: cart.items, itemCount: cart.item_count, source: 'vrs-cart-recs', didError: false } });
  } catch (err) {
    deferred.reject(err);
    btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = 'Añadir';
    if (msg) msg.textContent = err instanceof Error ? err.message : 'No se pudo añadir.';
  }
});
